import React from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import Form from "react-bootstrap/Form";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";

function KnowledgeCenterDetailPage() {
  return (
    <>
      <Header />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar/>
      <main id="main-content" className="knowledge">
        <div className="knowledge-header">
          <h2 className="knowledge-header-title">Modules</h2>
          <div className="knowledge-header-option">
            {/* search-bar */}
            <div className="search-box">
              <form action="#" method="post">
                <div className="form-group">
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Search modules by text, keywords, etc..."
                  />
                  <input
                    type="submit"
                    name="submit"
                    value="submit"
                    className="submit-btn"
                  />
                </div>
              </form>
            </div>
            {/* dropdown-filter */}
            <div className="dropdown-filter">
              <Form.Select size="lg" aria-label="Default select example">
                <option value="largecap">English</option>
                <option value="smallcap">Hindi</option>
                <option value="midcap">French</option>
              </Form.Select>
            </div>
            {/* switch tab */}
            <ul
              className="nav nav-tabs filter-tabs"
              id="knowledgeTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="module-tab"
                  data-toggle="tab"
                  data-target="#module-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="module-tab-pane"
                  aria-selected="true"
                >
                  Modules
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="video-tab"
                  data-toggle="tab"
                  data-target="#video-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="video-tab-pane"
                  aria-selected="false"
                >
                  Videos
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="tab-content refer-tab-content" id="knowledgeTabContent">
          <div
            className="tab-pane fade show active"
            id="module-tab-pane"
            role="tabpanel"
            aria-labelledby="module-tab"
            tabIndex={0}
          >
            <div className="knowledge-info">
              <h2 className="knowledge-info-heading">
                Introduction to Stock Market{" "}
                <span className="text-green">20 Chapters</span>
              </h2>
              <div className="expand-table">
                <div className="row border-parent">
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <a href="/knowledgeCentre-module" />
                      <h4 className="knowledge-info-card-title">
                        Learn Investing with the Experts
                      </h4>
                      <ul className="knowledge-info-card-text">
                        <p>Class Details :- </p>
                        <li>- Importance of investing</li>
                        <li>- Right time to invest</li>
                        <li>- Need of/Control during investment</li>
                        <li>- Waiting/ worrying while investing</li>
                        <li>- Balance in investing</li>
                        <li>- Need of/Control during investment</li>
                        <li>- Waiting/ worrying while investing</li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        Difference between Savings & Investments
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        Child Investmemnt Plans
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        Retirement Planning
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        How to Invest in Stock Market
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        What is a Demat Account
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        Who is a Trader?{" "}
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        What is Investing?
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        What is Offer for Sale ( OFS )
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        How to Invest{" "}
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        How to Invest
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        How to Invest
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        How to Invest
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-6 col-xl-4 bottom-25">
                    <div className="knowledge-info-card band">
                      <h4 className="knowledge-info-card-title">
                        How to Invest
                      </h4>
                      <p className="knowledge-info-card-text">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. Lorem Ipsum
                        is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="more-btn">View More</div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="video-tab-pane"
            role="tabpanel"
            aria-labelledby="video-tab"
            tabIndex={0}
          ></div>
        </div>
      </main>
    </>
  );
}

export default KnowledgeCenterDetailPage;
